import { render, staticRenderFns } from "./zu1_1.vue?vue&type=template&id=23f96938&scoped=true&"
import script from "./zu1_1.vue?vue&type=script&lang=js&"
export * from "./zu1_1.vue?vue&type=script&lang=js&"
import style0 from "./zu1_1.vue?vue&type=style&index=0&id=23f96938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f96938",
  null
  
)

export default component.exports